import React from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import logoImg from '../img/logo.png';
import { connect } from 'react-redux';
import { signin } from '../modules/actions/user';
// import mapStateToProps from "react-redux/es/connect/mapStateToProps";

import '../styles/signin.css';


class SignIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // "authenticated" : false
            rememberMe: false,
            username: ''
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleSignin = this.handleSignin.bind(this);
        // this.handleRemember = this.handleRemember.bind(this);
        // this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
        const rememberMe = localStorage.getItem('rememberMe') === 'true';
        //since localStorage persists data as string, ==='true' not === true
        //comparison!
        //localStorage stores data as string only!
        const username = rememberMe ? localStorage.getItem('username') : '';
        const password = rememberMe ? localStorage.getItem('password') : '';
        this.setState({username, password, rememberMe});
    }

    handleChange(event) {
        let values = this.state;
        // console.log('values: ',values);
        // console.log('event target', event.target);
        // console.log('target: ', event.target.name);
        values[event.target.name] = event.target.value;
        this.setState(values);
        // console.log(values, this.state);

        const input = event.target;
        const value = input.type === 'checkbox' ? input.checked: input.value;

        // console.log("rmb value", value);
        this.setState({ // this.setState 안 되는 이유??
            [input.name]: value
        });
    }

    async handleSignin(e){
        // let that = this;
        // e.preventDefault();
        // e.stopPropagation();
        const rememberMe = this.state.rememberMe;
        const username  = this.state.username;
        const password  = this.state.password;
        // console.log('this state', this.state.username);
        // console.log('rmb me', rememberMe);
        localStorage.setItem('rememberMe', rememberMe);
        localStorage.setItem('username', rememberMe ? username : '');
        localStorage.setItem('password', rememberMe ? password : '');

        let result = await this.props.dispatch(signin(this.state));

        // console.log("result??", result);
        // console.log("response",response);
        // console.log("this state", this.state);
        console.log(result === "no user");
        if(result === "no user"){
            Swal.fire({
                                title: 'Error!',
                                text: 'The user does not exist',
                                type: 'error',
                                confirmButtonText: 'Cool'
                            })
        }else if(result === "wrong password"){
            Swal.fire({
                title: 'Error!',
                text: 'Wrong password. Try again.',
                type: 'error',
                confirmButtonText: 'Cool'
            })
        }

        //replace axios -> this.props.blahblah
        // the benefit of using global state is you can reduce the no of network request because you can share variable across multiple pages
        // so the app will be faster
        //this.props가 global state임.

        // axios.post('https://spice-api.pearlfall.now.sh'+`/users/signin`, this.state)
        //     .then(function (response) {
        //         console.log('response', response);
        //         if(response.data.status === 'Success'){
        //             axios.defaults.headers.common['Authorization'] = response.data.token; //whenever going dashboard page,
        //             //header를 axios로! (simple way)
        //             that.setState({"authenticated" : true}); //this.setState안 됨!
        //             //browser sends token to dashboard, no need to send ?username
        //             // axios.get('https://spice-api.pearlfall.now.sh'+`/users/getUser`)
        //             //     .then(function (response) {
        //             //         window.alert('response:'+ JSON.stringify(response.data));
        //             //     });
        //             // Swal.fire({
        //             //     title: 'Success!',
        //             //     text: 'Successfully signed',
        //             //     type: 'success',
        //             //     confirmButtonText: 'Next'
        //             // })
        //             //     .then(()=>{
        //             //         console.log("Dismissed");
        //             //         sessionStorage.setItem("username", response.data.user.username);
        //             //        // window.location.assign('http://localhost:3001/dashboard/buyer')
        //             //
        //             //     })
        //         }else{
        //             Swal.fire({
        //                 title: 'Error!',
        //                 text: response.data.message,
        //                 type: 'error',
        //                 confirmButtonText: 'Cool'
        //             })
        //         }
        //     })
        //     .catch(function (error) {
        //         console.log(error);
        //     })
    }

    // handleRemember(event){
    //     let that = this;
    //     const input = event.target;
    //     const value = input.type === 'checkbox' ? input.checked: input.value;
    //
    //     console.log("rmb value", value);
    //     this.setState({ // this.setState 안 되는 이유??
    //         [input.name]: value
    //     });
    // };
    //
    // handleFormSubmit(){
    //     const rememberMe = this.state.rememberMe;
    //     const username  = this.state.username;
    //     console.log('this state', this.state.username);
    //     console.log('rmb me', rememberMe);
    //     localStorage.setItem('rememberMe', rememberMe);
    //     localStorage.setItem('username', rememberMe ? username : '');
    // }

    render() {
        if (this.props.isAuthenticated) //this.state (local state) -> this.props
        {
            if (this.props.user.type==="Buyer")
                return (
                    <Redirect to={{
                        pathname: "/dashboard/buyer"
                        // pathname: "/"
                    }}/>
                ); else if (this.props.user.type==="Seller")
                return (
                    <Redirect to={{
                        pathname: "/dashboard/request"
                        // pathname: "/"
                    }}/>
                )
        } else {
            return (
                <React.Fragment>
                    <div className="signin">
                        <h1 className="text-center signin-text">
                            <img src={logoImg} style={{
                                "height": "64px", "width": "64px"
                            }}/>
                            <br/>
                            Sign In</h1>
                        <Container fluid={true}>
                            {/*<Row>*/}
                            {/*    <Col xs="4"></Col>*/}
                            {/*    <Col xs="4">*/}
                            <body className="text-center">
                            <form className="form-signin"
                                // onSubmit={this.handleFormSubmit.bind(this)}
                            >
                                <input type="text" id="username" name="username" className="form-control"
                                       value={this.state.username}
                                       placeholder="Username"
                                       required autoFocus onChange={this.handleChange.bind(this)}/>
                                <input type="password" id="password" name="password" className="form-control"
                                       value={this.state.password}
                                       placeholder="Password"
                                       required onChange={this.handleChange.bind(this)}/>
                                <div className="checkbox mb-3">
                                    <label>
                                        <input type="checkbox" name="rememberMe"
                                               checked={this.state.rememberMe} onChange={this.handleChange.bind(this)}/> Remember me
                                    </label>
                                </div>
                                {/*<button className="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>*/}
                                <Button onClick={this.handleSignin.bind(this)}>Sign In</Button>
                            </form>
                            </body>
                            {/*    </Col>*/}
                            {/*    <Col xs="4"></Col>*/}
                            {/*</Row>*/}
                        </Container>
                    </div>
                </React.Fragment>

            );
        }
    }
}

function mapStateToProps(store){ //global store
    return {
        user: store.auth.user,
        isAuthenticated: store.auth.isAuthenticated // store라는 global store안에 sub store인 auth / persistent / runtime module 주에 선택하고
        //그 안에서 auth인 경우 isAuthenticated / user / tokens에서 선택하는 것
    };
}
export default withRouter(connect(mapStateToProps)(SignIn));
